var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCrossReject = function SvgIconCrossReject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#6498D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6963 18.6965C18.9921 18.4006 18.9921 17.9209 18.6963 17.6251L13.0714 11.999L18.6965 6.3751C18.9923 6.0793 18.9923 5.59971 18.6965 5.30391C18.4006 5.00811 17.9209 5.00811 17.6251 5.30391L12.0002 10.9276L6.37764 5.30393C6.08184 5.00807 5.60225 5.00807 5.30645 5.30393C5.01065 5.59979 5.01065 6.07947 5.30645 6.37533L10.9288 11.9988L5.30393 17.6226C5.00807 17.9184 5.00807 18.398 5.30393 18.6938C5.59979 18.9896 6.07947 18.9896 6.37533 18.6938L12 13.0702L17.6252 18.6965C17.921 18.9923 18.4005 18.9923 18.6963 18.6965Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCrossReject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_cross_reject.8c3740cc.svg";
export { ForwardRef as ReactComponent };